// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a59cd006","703":"890f464f"}[chunkId] + ".chunk.js";
};